import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Avatar from '../avatar'
import PanelLayout from './panel_layout'
import Dummy from '../dummy'
import ProfileInfoPanelPlaceholder from '../placeholder/profile_info_panel_placeholder'
import { me } from '../../initial_state'
import { openModal } from '../../actions/modal'
import { MODAL_TOP_FRIENDS_EDIT, MODAL_TOP_FRIENDS_VIEW } from '../../constants'
import { fetchFriends } from '../../actions/friends'

class TopFriendsPanel extends ImmutablePureComponent {

  componentDidMount() {
    const { account } = this.props
    if (!!account) {
      this.props.onFetchFriends(account.get('id'))
    }
  }

  componentDidUpdate(prevProps) {
    const { account } = this.props
    if (account !== prevProps.account || (!!account && prevProps.account && account.get('id') !== prevProps.account.get('id'))) {
      this.props.onFetchFriends(account.get('id'))
    }
  }

  handleOnEdit = () => {
    const accountId = this.props?.account ? this.props.account.get('id') : null
    this.props.onOpenEdit(accountId)
  }

  handleOnView = () => {
    const accountId = this.props?.account ? this.props.account.get('id') : null
    this.props.onOpenView(accountId)
  }

  render() {
    const {
      isXS,
      account,
      noPanel,
      friendAccounts,
    } = this.props

    if (!account) return null

    const Wrapper = noPanel ? Dummy : PanelLayout
    const isMine = account.get('id') === me

    if (!isMine && (!friendAccounts || friendAccounts.size === 0)) return null

    if (!account && !noPanel) {
      return (
        <Wrapper title='Top Friends'>
          <ProfileInfoPanelPlaceholder />
        </Wrapper>
      )
    }

    const containerClasses = !isXS ?
      [_s.d, _s.px15, _s.pb5, _s.flexRow, _s.flexWrap].join(' ') : 
      [_s.d, _s.overflowYHidden, _s.overflowXScroll, _s.noScrollbar, _s.pl10, _s.pr15, _s.flexRow].join(' ')

    return (
      <PanelLayout
        noPadding
        headerButtonTitle={isMine ? 'Edit' : 'View'}
        headerButtonAction={isMine ? this.handleOnEdit : this.handleOnView}
        title='Top Friends'
      >
        <div className={containerClasses}>
          {friendAccounts ? friendAccounts.map((account) => {
            return (
              <NavLink
                key={`shortcut-avatar-${account.get('id')}`}
                to={`/${account.get('acct')}`}
                className={[_s.d, _s.mr10, _s.circle, _s.mb10, _s.noUnderline, _s.bgSecondary, _s.cursorPointer].join(' ')}
              >
                <Avatar
                  size={isXS ? 40 : 60}
                  account={account}
                />
              </NavLink>
            )
          }) : null}
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state, { account }) => {
  const accountId = !!account ? account.get('id') : null
  const friendAccountIds = accountId ? state.getIn(['user_lists', 'friends', accountId, 'items']) : null

  // Find accounts by looking at friendAccountIds
  const friendAccounts = friendAccountIds ? friendAccountIds.map((friendAccountId) =>
    state.getIn(['accounts']).find(account => {
      return account.get('id') === friendAccountId
    })
  ) : null;

  return {
    accountId,
    friendAccounts,
    friendAccountIds,
    isError: accountId ? state.getIn(['user_lists', 'friends', accountId, 'isError']) : null,
    isLoading: accountId ? state.getIn(['user_lists', 'friends', accountId, 'isLoading']) : null,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetchFriends(accountId) {
    if (!accountId) return
    dispatch(fetchFriends(accountId))
  },
  onOpenEdit(accountId) {
    if (!accountId) return
    dispatch(openModal(MODAL_TOP_FRIENDS_EDIT, {accountId}))
  },
  onOpenView(accountId) {
    if (!accountId) return
    dispatch(openModal(MODAL_TOP_FRIENDS_VIEW, {accountId}))
  },
})

TopFriendsPanel.propTypes = {
  account: ImmutablePropTypes.map,
  noPanel: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(TopFriendsPanel)